// extracted by mini-css-extract-plugin
export default {"mediaItem__container":"MediaItem_mediaItem__container__HwoRf","mediaItem__frame":"MediaItem_mediaItem__frame__Fzoli","mediaItem__blur":"MediaItem_mediaItem__blur__UYOLu"};